export default {
  evnetTrack: '/api/common/user-behavior-record',
  newTrack: '/api/user-behavior-track/record',
  riskTrack: '/api/common/addRiskControlTracking',
  check: '/api/auth/check-ext-expired',
  upload: '/api/auth/ext-info',
  getPhone: '/api/refusal/introduce/get_phone',
  sendSms: '/api/user/send-sms-new',
  loginSms: '/api/refusal/introduce/login-sms-new',
  baseInfo: '/api/refusal/introduce/apply',
  processInfo: '/api/refusal/introduce/loading',
  getLink: '/api/refusal/introduce/get-link',
  livenessTransmission: '/api/refusal/introduce/liveness_transmission',
  phoneIsTrue: '/api/user/phone-exist',
  getRouter: '/api/refusal/introduce/get-router',
  updateUserExtInfoValue: '/api/user/updateUserExtInfoValue',
  login: {
    haveSmsCode: '/api/user/pop-voice-code',
    sendSms: '/api/user/send-sms',
    loginSms: '/api/user/login-sms'
  },
  home: {
    getNext: '/api/loan/get-next-step',
    increaseCreditPop: '/api/common/increaseCreditPop',
    fullAmount: '/api/loan/full-amount-apply',
    auto: '/api/index/auto-apply-config',
    cancelAutoApply: '/api/index/cancel-auto-apply'
  },
  faq: {
    getTypeList: '/api/faq/getTypeList',
    getFaqList: '/api/faq/getFaqList',
    queryFaq: '/api/faq/queryFaq',
    faqScore: '/api/faq/faqScore'
  },
  user: {
    customerServiceInfo: '/api/common/customerServiceInfo',
    getColumns: '/api/common/dict-list-new',
    complaint: '/api/user/complaint',
    logout: '/api/user/logout',
    baseInfo: '/api/user/baseInfo',
    checkLoanStatus: '/api/order/check-user-loan-status',
    creditInfo: '/api/user/creditInfo',
    repayOrderBase: '/api/order/repaid-order-base',
    bankCardList: '/api/auth/bank-card-list',
    getModifySteps: '/api/auth/get-modify_steps',
    bankList: '/api/common/bank-list',
    changeCard: '/api/auth/modify-bankcard'
  },
  verify: {
    amountSteps: '/api/auth/getAwardAmount',
    save: '/api/auth/save-user-info-new',
    nextStepNew: '/api/loan/get-next-step-New',
    check: '/api/auth/check-new'
  },
  loan: {
    products: '/api/index/product-packaging-base',
    orderList: '/api/order/list-base',
    orderDetail: '/api/order/order-detail-base64-flexible',
    loanCertificate: '/api/order/loan-certificate',
    repaymentChannel: '/api/order/repayment-channel',
    repaymentDetail: '/api/order/repayment-detail',
    delayDetail: '/api/delay/calculate-delay-flexible',
    apply: '/api/loan/apply',
    loanDetail: '/api/loan/loan-apply-detail',
    loanOrderList: '/api/index/loan-order-list'
  }
}
